/**************
 Cart V2
 ***************/

const miniCartGiftItems = [
    { id: 52842351591789, quantity: 1, properties: { _gift: true } },
    { id: 52842350084461, quantity: 1, properties: { _gift: true } }
];

// Stick Travel — added on top of the base gift set only for family pack subscriptions.
const miniCartPremiumGiftItem = { id: 53513002090861, quantity: 1, properties: { _gift: true } };

const miniCartProductCache = {};
const miniCartVariantSellingPlanOptions = {};
let miniCartActionInProgress = false;

function miniCartVisibleItems() {
    return (cart.items || []).filter(item => parseInt(item.final_price, 10) > 0 && !(item.properties && item.properties._gift));
}

function miniCartPlanId(item) {
    if (!item) return null;
    if (item.properties && item.properties._plan) return item.properties._plan;
    if (item.properties && item.properties._selling_plan_offer) return item.properties._selling_plan_offer;
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        return item.selling_plan_allocation.selling_plan.id;
    }
    const sellingPlanOptions = miniCartSellingPlanOptions(item);
    if (sellingPlanOptions.length) return sellingPlanOptions[0].id;
    return null;
}

function miniCartSellingPlanOptions(item) {
    return item ? miniCartVariantSellingPlanOptions[item.variant_id] || [] : [];
}

function miniCartEscapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function miniCartCleanPlanName(value) {
    return String(value || '')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/\s+/g, ' ')
        .trim();
}

function miniCartPlanFrequencyText(plan) {
    const frequencyOption = (plan && plan.options || []).find(option => option.name && option.name.toLowerCase().includes('frequency'));
    const source = miniCartCleanPlanName(frequencyOption ? frequencyOption.value : plan && plan.name);
    const match = source.match(/(\d+)\s*-?\s*(week|month)/i);
    if (!match) return source;

    const amount = parseInt(match[1], 10);
    const unit = match[2].toLowerCase();
    if (!Number.isFinite(amount)) return source;

    if (unit === 'week') {
        const months = amount % 4 === 0 ? amount / 4 : null;
        if (months) return `${months} ${months === 1 ? 'Month' : 'Months'}`;
        return `${amount} ${amount === 1 ? 'Week' : 'Weeks'}`;
    }

    return `${amount} ${amount === 1 ? 'Month' : 'Months'}`;
}

function miniCartPlanQuantity(plan) {
    const frequencyOption = (plan && plan.options || []).find(option => option.name && option.name.toLowerCase().includes('frequency'));
    const source = miniCartCleanPlanName(frequencyOption ? frequencyOption.value : plan && plan.name);
    const match = source.match(/(\d+)\s*-?\s*(week|month)/i);
    if (!match) return null;
    const amount = parseInt(match[1], 10);
    const unit = match[2].toLowerCase();
    if (!Number.isFinite(amount)) return null;
    const weeks = unit === 'month' ? amount * 4 : amount;
    return weeks / 4;
}

function miniCartPlanDiscountPercent(allocation, plan) {
    const nameMatch = miniCartCleanPlanName(plan && plan.name).match(/(\d+(?:\.\d+)?)%/);
    if (nameMatch) return Math.round(parseFloat(nameMatch[1]));

    const adjustment = plan && plan.price_adjustments && plan.price_adjustments[0];
    if (adjustment && adjustment.value_type === 'percentage') return Math.round(parseFloat(adjustment.value));

    const compareAtPrice = parseInt(allocation && allocation.compare_at_price, 10);
    const planPrice = parseInt(allocation && allocation.price, 10);
    if (Number.isFinite(compareAtPrice) && Number.isFinite(planPrice) && compareAtPrice > planPrice) {
        return Math.round(((compareAtPrice - planPrice) / compareAtPrice) * 100);
    }

    return 0;
}

function miniCartPlanLabel(allocation, plan) {
    return miniCartCleanPlanName(plan && plan.name) || 'Subscription plan';
}

function miniCartParseSellingPlanIds(value) {
    return String(value || '')
        .split(/[\s,]+/)
        .map(id => id.trim())
        .filter(Boolean);
}

function miniCartNormalizeHandle(value) {
    return String(value || '').replace(/^\/?products\//, '').replace(/^\//, '').trim();
}

function miniCartNormalizeOption(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
}

function miniCartFamilyPackConfig() {
    const customizerConfig = typeof miniCartFamilyPackOffer !== 'undefined' ? miniCartFamilyPackOffer : {};
    const subscribeBaseLabel = Object.prototype.hasOwnProperty.call(customizerConfig, 'subscribeLabel') ? customizerConfig.subscribeLabel : 'Subscribe & Save';
    const subscribeDiscount = Object.prototype.hasOwnProperty.call(customizerConfig, 'subscribeDiscount') ? customizerConfig.subscribeDiscount : '';
    const subscribeLabel = [subscribeBaseLabel, subscribeDiscount].map(value => String(value || '').trim()).filter(Boolean).join(' ');

    // Editor toggle: an older saved config predates the setting, so a missing flag means "show".
    const showCard = Object.prototype.hasOwnProperty.call(customizerConfig, 'showCard')
        ? customizerConfig.showCard !== false
        : true;

    // The pack is two explicitly-configured variants (Product A + Product B), each set in the
    // customizer by handle + variant ID. They can be different products (e.g. 1 adult + 1 kids).
    const rawSlots = Array.isArray(customizerConfig.slots) ? customizerConfig.slots : [];
    const slots = rawSlots.map(slot => ({
        handle: miniCartNormalizeHandle(slot && slot.handle),
        variantId: String((slot && slot.variantId) || '').trim(),
        label: (slot && slot.label) || ''
    })).filter(slot => slot.handle && slot.variantId);

    return {
        showCard: showCard,
        slots: slots,
        sellingPlanId: String(customizerConfig.sellingPlanId || '693054964077'),
        title: customizerConfig.title || 'Add your family pack',
        productTitle: customizerConfig.productTitle || 'The Foundational Blend - Family Pack',
        image: customizerConfig.image || '',
        subscribeBaseLabel: subscribeBaseLabel || 'Subscribe & Save',
        subscribeLabel: subscribeLabel || 'Subscribe & Save',
        otpLabel: customizerConfig.otpLabel || 'One-time purchase'
    };
}

// Build the family-pack subscribe label from the real prices so the badge always reflects
// what SKIO actually charges. The discount is rounded, so a 39.9% plan renders as "40%".
function miniCartFamilyPackSubscribeLabel(config, compareTotal, subscriptionTotal) {
    const base = (config && config.subscribeBaseLabel) || 'Subscribe & Save';
    if (compareTotal > subscriptionTotal && compareTotal > 0) {
        const percent = Math.round(((compareTotal - subscriptionTotal) / compareTotal) * 100);
        if (percent > 0) return `${base} ${percent}%`;
    }
    return (config && config.subscribeLabel) || base;
}

function miniCartFindVariantByFlavor(product, flavorName) {
    const target = miniCartNormalizeOption(flavorName);
    const variants = product && product.variants || [];

    return variants.find(variant => {
        const values = [variant.option1, variant.option2, variant.option3, variant.public_title, variant.title];
        return values.some(value => miniCartNormalizeOption(value) === target);
    }) || null;
}

function miniCartFindVariantById(product, variantId) {
    const target = String(variantId || '').trim();
    if (!target) return null;
    const variants = product && product.variants || [];
    return variants.find(variant => String(variant.id) === target) || null;
}

function miniCartFindSellingPlanAllocation(variant, sellingPlanId) {
    return (variant && variant.selling_plan_allocations || []).find(allocation => (
        String(allocation.selling_plan_id) === String(sellingPlanId)
    )) || null;
}

function miniCartFamilyVariantPayload(variant, product, allocation) {
    return {
        id: variant.id,
        flavor: miniCartVariantFlavor(variant),
        price: parseInt(variant.price, 10) || 0,
        subscriptionPrice: parseInt(allocation && allocation.price, 10) || parseInt(variant.price, 10) || 0,
        compareAtPrice: parseInt(allocation && allocation.compare_at_price, 10) || parseInt(variant.compare_at_price, 10) || parseInt(variant.price, 10) || 0,
        image: miniCartVariantImage(variant, product),
        available: variant.available !== false
    };
}

async function miniCartResolveFamilyPackOffer(items) {
    // A family pack already in the cart (added here or from the PDP buy box)
    // suppresses the upsell even when other items sit alongside it.
    if (items.some(miniCartIsFamilyPackItem)) return null;
    // items.length is only used to detect an already-family cart; an empty cart (the
    // "most customers add" grid) still needs to resolve the configured pack offer.
    if (miniCartIsFamilyCart(items)) return null;

    const config = miniCartFamilyPackConfig();
    // Hidden from the theme editor: bail before the product fetches below.
    if (!config.showCard) return null;
    if (config.slots.length < 2) return null;

    // Fetch each slot's product in parallel, then locate the exact variant by ID.
    const products = await Promise.all(config.slots.map(slot => miniCartFetchProduct(slot.handle)));

    const variants = config.slots.map((slot, index) => {
        const product = products[index];
        const variant = miniCartFindVariantById(product, slot.variantId);
        if (!variant) return null;
        const allocation = miniCartFindSellingPlanAllocation(variant, config.sellingPlanId);
        const payload = miniCartFamilyVariantPayload(variant, product, allocation);
        // Honor the optional customizer label override; otherwise fall back to the variant flavor.
        payload.flavor = slot.label || payload.flavor;
        return payload;
    });

    if (variants.some(variant => !variant || !variant.available)) return null;

    return { config, variants };
}

function miniCartProductUpsellRules() {
    const customizerRules = typeof miniCartProductUpsells !== 'undefined' && Array.isArray(miniCartProductUpsells)
        ? miniCartProductUpsells
        : [];
    const rules = customizerRules;

    return rules.map(rule => ({
        triggerHandle: miniCartNormalizeHandle(rule.triggerHandle),
        upsellHandle: miniCartNormalizeHandle(rule.upsellHandle)
    })).filter(rule => rule.triggerHandle && rule.upsellHandle);
}

function miniCartFindProductUpsellRule(items) {
    const handles = items.map(item => miniCartNormalizeHandle(item.handle));

    return miniCartProductUpsellRules().find(rule => (
        handles.includes(rule.triggerHandle) && !handles.includes(rule.upsellHandle)
    )) || null;
}

function miniCartVariantFlavor(variant) {
    if (!variant) return '';
    return variant.option1 || variant.public_title || variant.title || 'Default';
}

function miniCartVariantImage(variant, product) {
    const image = variant && variant.featured_image && variant.featured_image.src
        ? variant.featured_image.src
        : product && product.featured_image;
    return image ? `${image}&width=320` : '';
}

async function miniCartResolveProductUpsell(items) {
    const rule = miniCartFindProductUpsellRule(items);
    if (!rule) return null;

    const product = await miniCartFetchProduct(rule.upsellHandle);
    if (!product || !(product.variants || []).length) return null;

    const variants = (product.variants || []).map(variant => ({
        id: variant.id,
        flavor: miniCartVariantFlavor(variant),
        price: parseInt(variant.price, 10) || 0,
        compareAtPrice: parseInt(variant.compare_at_price, 10) || 0,
        image: miniCartVariantImage(variant, product),
        available: variant.available !== false
    }));

    return { product, variants };
}

// Second card of the empty-cart "most customers add" grid: same shape as
// miniCartResolveProductUpsell above, resolved from a fixed configured handle instead of a
// cart-trigger rule (there's no cart to trigger from when the drawer is empty).
async function miniCartResolveEmptyUpsellProduct() {
    const handle = typeof miniCartEmptyUpsellHandle !== 'undefined' ? miniCartEmptyUpsellHandle : '';
    if (!handle) return null;

    const product = await miniCartFetchProduct(handle);
    if (!product || !(product.variants || []).length) return null;

    const customImage = typeof miniCartEmptyUpsellCard2Image !== 'undefined' ? miniCartEmptyUpsellCard2Image : '';
    const variants = (product.variants || []).map(variant => ({
        id: variant.id,
        flavor: miniCartVariantFlavor(variant),
        price: parseInt(variant.price, 10) || 0,
        compareAtPrice: parseInt(variant.compare_at_price, 10) || 0,
        image: customImage || miniCartVariantImage(variant, product),
        available: variant.available !== false
    }));

    // miniCartRenderProductUpsell preselects the first available variant; move the
    // configured one to the front so it opens preselected instead.
    const preselectedId = typeof miniCartEmptyUpsellVariantId !== 'undefined' ? String(miniCartEmptyUpsellVariantId || '') : '';
    if (preselectedId) {
        const preselectedIndex = variants.findIndex(variant => String(variant.id) === preselectedId);
        if (preselectedIndex > 0) variants.unshift(variants.splice(preselectedIndex, 1)[0]);
    }

    return { product, variants };
}

function miniCartAllowedSellingPlanIds(item) {
    if (!item || typeof miniCartAllowedSellingPlans === 'undefined') return [];

    const rules = Array.isArray(miniCartAllowedSellingPlans)
        ? miniCartAllowedSellingPlans
        : Object.keys(miniCartAllowedSellingPlans).map(handle => ({
            handle,
            ids: miniCartAllowedSellingPlans[handle]
        }));
    const variantRule = rules.find(rule => rule.variantId && String(rule.variantId) === String(item.variant_id));

    if (variantRule) return miniCartParseSellingPlanIds(variantRule.ids);

    return rules.reduce((ids, rule) => {
        if (!rule.handle || miniCartNormalizeHandle(rule.handle) !== miniCartNormalizeHandle(item.handle) || rule.variantId) return ids;
        return ids.concat(miniCartParseSellingPlanIds(rule.ids));
    }, []);
}

async function miniCartFetchProduct(handle) {
    if (!handle) return null;
    if (miniCartProductCache[handle]) return miniCartProductCache[handle];

    const response = await fetch(`${Shopify.routes.root}products/${handle}.js`);
    if (!response.ok) return null;

    const product = await response.json();
    miniCartProductCache[handle] = product;
    return product;
}

async function miniCartResolveSellingPlans(item) {
    if (!item || miniCartSellingPlanOptions(item).length) return miniCartSellingPlanOptions(item);
    if (!item.handle || !item.variant_id) return null;

    const customizerAllowedPlanIds = miniCartAllowedSellingPlanIds(item);
    if (!customizerAllowedPlanIds.length) {
        miniCartVariantSellingPlanOptions[item.variant_id] = [];
        return [];
    }

    try {
        const product = await miniCartFetchProduct(item.handle);
        if (!product) return [];

        const variant = (product.variants || []).find(currentVariant => String(currentVariant.id) === String(item.variant_id));
        const skioGroups = (product.selling_plan_groups || []).filter(group => String(group.app_id).toUpperCase() === 'SKIO');
        const allowedPlanIds = skioGroups.reduce((ids, group) => {
            (group.selling_plans || []).forEach(plan => ids.push(String(plan.id)));
            return ids;
        }, []);
        const planById = skioGroups.reduce((plans, group) => {
            (group.selling_plans || []).forEach(plan => {
                plans[plan.id] = plan;
            });
            return plans;
        }, {});
        const seenPlanIds = [];
        const options = (variant && variant.selling_plan_allocations || []).reduce((sellingPlans, allocation) => {
            const planId = allocation && allocation.selling_plan_id;
            if (
                !planId ||
                !allowedPlanIds.includes(String(planId)) ||
                !customizerAllowedPlanIds.includes(String(planId)) ||
                seenPlanIds.includes(String(planId))
            ) return sellingPlans;
            seenPlanIds.push(String(planId));

            const plan = planById[planId] || {};
            sellingPlans.push({
                id: planId,
                label: miniCartPlanLabel(allocation, plan),
                price: parseInt(allocation.price, 10) || 0,
                compareAtPrice: parseInt(allocation.compare_at_price, 10) || 0,
                quantity: miniCartPlanQuantity(plan)
            });
            return sellingPlans;
        }, []);

        miniCartVariantSellingPlanOptions[item.variant_id] = options;
        return options;
    } catch (error) {
        return [];
    }
}

async function miniCartResolveSellingPlanId(item) {
    if (!item) return null;
    if (item.selling_plan_allocation || miniCartPlanId(item)) return miniCartPlanId(item);
    const sellingPlanOptions = await miniCartResolveSellingPlans(item);
    return sellingPlanOptions && sellingPlanOptions.length ? sellingPlanOptions[0].id : null;
}

async function miniCartHydrateSellingPlans(items) {
    await Promise.all(items.map(item => miniCartResolveSellingPlans(item)));
}

function miniCartPlanInfo(item) {
    const planId = miniCartPlanId(item);
    return planId && typeof planInformation !== 'undefined' ? planInformation[planId] : null;
}

function miniCartIsFamilyItem(item) {
    return Boolean(item && item.properties && item.properties._variety);
}

function miniCartIsFamilyPackItem(item) {
    return Boolean(item && item.properties && item.properties._family_pack);
}

function miniCartIsFamilyCart(items) {
    return (items.length > 1 && items.every(miniCartIsFamilyItem)) || (items.length > 0 && items.every(miniCartIsFamilyPackItem));
}

function miniCartMoney(amountInCents) {
    return price(amountInCents, true);
}

function miniCartNumericPrice(value) {
    if (!value) return null;
    const number = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) ? Math.round(number * 100) : null;
}

function miniCartDiscountPercent(items) {
    const item = items.find(currentItem => currentItem && currentItem.selling_plan_allocation);
    const sellingPlanName = item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.name
        : '';
    const match = String(sellingPlanName).match(/(\d+(?:\.\d+)?)%\s*(discount|off)/i);
    if (!match) return null;

    const percent = parseFloat(match[1]);
    return Number.isFinite(percent) && percent > 0 && percent < 100 ? percent : null;
}

function miniCartSellingPlanCompareTotal(items) {
    return items.reduce((sum, item) => {
        const allocation = item && item.selling_plan_allocation || {};
        const compareAtPrice = parseInt(allocation.compare_at_price, 10);
        const planPrice = parseInt(allocation.price, 10);

        if (Number.isFinite(compareAtPrice) && Number.isFinite(planPrice) && compareAtPrice > planPrice) {
            return sum + (compareAtPrice * item.quantity);
        }

        const currentPlanId = miniCartCurrentSellingPlanId(item);
        const currentOption = miniCartSellingPlanOptions(item).find(option => String(option.id) === currentPlanId);
        if (currentOption && currentOption.compareAtPrice > currentOption.price) {
            return sum + (currentOption.compareAtPrice * item.quantity);
        }

        return sum;
    }, 0);
}

function miniCartSubscriptionSavings(planInfo, items, isSubscription, isFamily) {
    if (!isSubscription || !items.length) return null;

    const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
    const subscriptionTotal = miniCartDisplaySubtotal(items, isSubscription, isFamily);
    const shopifyBaseTotal = items.reduce((sum, item) => {
        const originalLinePrice = parseInt(item.original_line_price, 10);
        if (Number.isFinite(originalLinePrice) && originalLinePrice > 0) return sum + originalLinePrice;

        const originalPrice = parseInt(item.original_price, 10);
        if (Number.isFinite(originalPrice) && originalPrice > 0) return sum + (originalPrice * item.quantity);

        return sum;
    }, 0);
    const fallbackBaseUnitPrice = miniCartNumericPrice(planInfo && planInfo.price);
    const configuredBaseTotal = fallbackBaseUnitPrice ? fallbackBaseUnitPrice * quantity : 0;
    const sellingPlanCompareTotal = miniCartSellingPlanCompareTotal(items);
    const discountPercent = miniCartDiscountPercent(items);
    const discountBaseTotal = discountPercent
        ? Math.round((subscriptionTotal / (1 - (discountPercent / 100))) / 100) * 100
        : 0;
    const baseTotal = [shopifyBaseTotal, sellingPlanCompareTotal, configuredBaseTotal, discountBaseTotal]
        .find(total => total > subscriptionTotal) || 0;
    const savings = baseTotal - subscriptionTotal;

    if (savings <= 0) return null;
    return { baseTotal, subscriptionTotal, savings };
}

function miniCartSavingsText(subscriptionSavings) {
    return subscriptionSavings ? `Save ${miniCartMoney(subscriptionSavings.savings)}` : '';
}

function miniCartFlavorText(item, isFamily, items) {
    if (isFamily && miniCartIsFamilyPackItem(item)) {
        // The PDP buy box lets shoppers pick each slot's flavor — read the real
        // _family_pack_flavor properties instead of assuming the default combo.
        const flavors = (items || [item])
            .map(currentItem => currentItem && currentItem.properties && currentItem.properties._family_pack_flavor)
            .filter(Boolean);
        if (flavors.length) return flavors.join(' + ');
        return 'Berry + Unflavored';
    }
    if (isFamily) return 'Variety Pack';
    if (!item || !item.variant_title) return '';
    return item.variant_title.split('/')[0].trim();
}

function miniCartTitle(item, isFamily) {
    if (isFamily && miniCartIsFamilyPackItem(item)) return miniCartFamilyPackConfig().productTitle;
    if (isFamily) return 'The Foundational Blend';
    return item ? item.product_title : '';
}

function miniCartDeliveryText(isSubscription, isFamily) {
    return isSubscription ? 'Deliver every:' : 'Delivery one-time';
}

function miniCartSelectText(isSubscription, isFamily) {
    if (isFamily) return 'Family Pack';
    return isSubscription ? 'Delivered for Billed every 4 weeks' : 'One-time purchase';
}

function miniCartCurrentSellingPlanId(item) {
    if (!item || !item.selling_plan_allocation || !item.selling_plan_allocation.selling_plan) return '';
    return String(item.selling_plan_allocation.selling_plan.id);
}

// Minimum units allowed for the item's active plan. The floor equals the plan's
// frequency-derived quantity (miniCartPlanQuantity: 4 weeks -> 1, 12 weeks -> 3),
// which the hydrated options already store on plan.quantity. 12-week subscriptions
// cannot be sold below 3 units, so the quantity selector blocks decreasing past this.
function miniCartItemMinQuantity(item) {
    const currentPlanId = miniCartCurrentSellingPlanId(item);
    const currentOption = miniCartSellingPlanOptions(item).find(plan => String(plan.id) === currentPlanId);
    const value = currentOption && currentOption.quantity;
    return Number.isFinite(value) ? Math.max(1, Math.round(value)) : 1;
}

function miniCartRenderPlanSelect(items, isFamily) {
    const item = items[0];
    if (isFamily) {
        const currentPlanId = miniCartCurrentSellingPlanId(item);
        const config = miniCartFamilyPackConfig();
        const subscriptionTotal = items.reduce((sum, currentItem) => sum + currentItem.final_line_price, 0);
        const compareTotal = miniCartSellingPlanCompareTotal(items);
        const subscribeLabel = miniCartFamilyPackSubscribeLabel(config, compareTotal, subscriptionTotal);
        return `
                <label class="miniCartBodyItemPlanSelectWrap">
                    <span class="visually-hidden">Family pack purchase option</span>
                    <select class="miniCartBodyItemPlanSelect miniCartFamilyPlanSelect">
                        <option value="" ${currentPlanId ? '' : 'selected'}>${miniCartEscapeHtml(config.otpLabel)}</option>
                        <option value="${miniCartEscapeHtml(config.sellingPlanId)}" ${currentPlanId === String(config.sellingPlanId) ? 'selected' : ''}>${miniCartEscapeHtml(subscribeLabel)}</option>
                    </select>
                    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 7.5 10 12.5l5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </label>`;
    }

    const sellingPlanOptions = miniCartSellingPlanOptions(item);
    if (!sellingPlanOptions.length) return '';

    const currentPlanId = miniCartCurrentSellingPlanId(item);
    const totalQuantity = items.reduce((sum, currentItem) => sum + currentItem.quantity, 0);
    const keys = items.map(currentItem => currentItem.key).join('|');
    const subscriptionOptions = sellingPlanOptions.map(plan => `
                        <option value="${miniCartEscapeHtml(plan.id)}"${plan.quantity != null ? ` data-plan-quantity="${plan.quantity}"` : ''} ${currentPlanId === String(plan.id) ? 'selected' : ''}>${miniCartEscapeHtml(plan.label)}</option>`).join('');

    return `
                <label class="miniCartBodyItemPlanSelectWrap">
                    <span class="visually-hidden">Purchase option</span>
                    <select class="miniCartBodyItemPlanSelect" data-keys="${miniCartEscapeHtml(keys)}" data-quantity="${totalQuantity}">
                        <optgroup label="Full price">
                            <option value="" ${currentPlanId ? '' : 'selected'}>One-time purchase</option>
                        </optgroup>
                        <optgroup label="Subscription plans">${subscriptionOptions}
                        </optgroup>
                    </select>
                    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 7.5 10 12.5l5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </label>`;
}

function miniCartImage(item, isFamily) {
    if (isFamily) {
        const familyImage = miniCartFamilyPackConfig().image;
        if (familyImage) return familyImage;
    }
    if (!item || !item.image) return '';
    return `${item.image}&width=320`;
}

function miniCartComparePrice(subscriptionSavings) {
    return subscriptionSavings ? miniCartMoney(subscriptionSavings.baseTotal) : '';
}

// Aggregate the real line-level discounts Shopify applies to a grouped item (automatic
// discounts and discount codes) so the cart can show the discount name and the savings.
// Reads line_level_discount_allocations first, falling back to the legacy discounts array.
function miniCartLineDiscounts(items) {
    const titles = [];
    const seen = new Set();
    let totalDiscount = 0;

    items.forEach(item => {
        const allocations = (item && item.line_level_discount_allocations && item.line_level_discount_allocations.length)
            ? item.line_level_discount_allocations.map(allocation => ({
                amount: allocation.amount,
                title: allocation.discount_application && allocation.discount_application.title
            }))
            : ((item && item.discounts) || []).map(discount => ({ amount: discount.amount, title: discount.title }));

        allocations.forEach(({ amount, title }) => {
            const value = parseInt(amount, 10) || 0;
            if (value <= 0) return;
            totalDiscount += value;
            const label = miniCartCleanPlanName(title) || 'Discount';
            if (!seen.has(label)) {
                seen.add(label);
                titles.push(label);
            }
        });
    });

    if (totalDiscount <= 0) return null;
    return { totalDiscount, titles };
}

function miniCartDisplaySubtotal(items) {
    // Always reflect the real line prices so the displayed total matches what SKIO charges
    // at checkout (no hardcoded family-pack price).
    return items.reduce((sum, currentItem) => sum + currentItem.final_line_price, 0);
}

function miniCartRenderQuantity(items, isFamily) {
    if (isFamily || !items.length) return '';
    const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
    const keys = items.map(item => item.key).join('|');
    const minQuantity = miniCartItemMinQuantity(items[0]);
    return `
        <div class="miniCartQuantity" data-keys="${keys}" data-min-quantity="${minQuantity}">
            <button type="button" class="miniCartQuantityMinus" aria-label="Decrease quantity" ${quantity <= minQuantity ? 'disabled' : ''}>-</button>
            <span>${String(quantity).padStart(2, '0')}</span>
            <button type="button" class="miniCartQuantityPlus" aria-label="Increase quantity">+</button>
        </div>
    `;
}

// Optional microcopy explaining why "-" is locked once a subscription sits at its
// minimum (e.g. 12-week plans start at 3 units). Controlled from the customizer via
// miniCartQuantityLimits; the {min} token is replaced with the actual floor.
function miniCartRenderQuantityNote(items) {
    if (!items.length) return '';
    const limits = typeof miniCartQuantityLimits !== 'undefined' ? miniCartQuantityLimits : {};
    if (!limits.showMinNote || !limits.minNote) return '';
    const minQuantity = miniCartItemMinQuantity(items[0]);
    if (minQuantity <= 1) return '';
    const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
    if (quantity > minQuantity) return '';
    const text = String(limits.minNote).replace(/\{min\}/g, minQuantity);
    return `<p class="miniCartQuantityNote">${miniCartEscapeHtml(text)}</p>`;
}

function miniCartRenderItem(items, isFamily) {
    const item = items[0];
    const planInfo = miniCartPlanInfo(item);
    const isSubscription = Boolean(item && item.selling_plan_allocation);
    const subtotal = miniCartDisplaySubtotal(items, isSubscription, isFamily);
    const subscriptionSavings = miniCartSubscriptionSavings(planInfo, items, isSubscription, isFamily);
    const compare = miniCartComparePrice(subscriptionSavings);
    const savings = miniCartSavingsText(subscriptionSavings);
    // Surface Shopify automatic discounts / discount codes applied to the line: strike the
    // pre-discount total and show a badge with the discount name (e.g. "SAVE 20%").
    const lineDiscount = miniCartLineDiscounts(items);
    const originalLineTotal = items.reduce((sum, currentItem) => sum + (parseInt(currentItem.original_line_price, 10) || 0), 0);
    const compareDisplay = compare || (lineDiscount && originalLineTotal > subtotal ? miniCartMoney(originalLineTotal) : '');
    const discountBadge = lineDiscount
        ? `<span class="miniCartItemDiscountBadge">${miniCartEscapeHtml(lineDiscount.titles.join(' · '))}</span>`
        : '';
    const shouldShowSubscribe = !isSubscription && !isFamily && miniCartPlanId(item);
    const subscriptionControls = isSubscription || isFamily ? `
                <div class="miniCartBodyItemPlanRow">
                    <div class="miniCartBodyItemDelivery">${miniCartDeliveryText(isSubscription, isFamily)}</div>
                    ${savings ? `<span class="miniCartItemSubscribe">You ${savings}</span>` : ''}
                </div>
                ${miniCartRenderPlanSelect(items, isFamily)}` : '';
    const otpSubscribeButton = shouldShowSubscribe
        ? `<button type="button" class="miniCartOtpSubscribe" data-key="${miniCartEscapeHtml(item.key)}">Subscribe and get free shipping</button>`
        : '';

    return `
        <div class="miniCartBodyItem ${isFamily ? 'miniCartBodyItem--family' : ''}" data-key="${miniCartEscapeHtml(item.key)}" data-keys="${items.map(currentItem => miniCartEscapeHtml(currentItem.key)).join('|')}">
            <img class="miniCartBodyItemImage" src="${miniCartImage(item, isFamily)}" alt="${miniCartTitle(item, isFamily)}">
            <div class="miniCartBodyItemContent">
                <div class="miniCartBodyItemTitleRow">
                    <div class="miniCartBodyItemTitle">${miniCartTitle(item, isFamily)}</div>
                    <div class="miniCartBodyItemRemoveWrap">
                        <button type="button" class="miniCartBodyItemRemove" aria-label="Remove item">
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" viewBox="0 0 256 256">
                                <path fill="currentColor" d="M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16M96 40a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v8H96Zm96 168H64V64h128Zm-80-104v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0m48 0v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0"></path>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="miniCartBodyItemFlavor">Flavor: ${miniCartFlavorText(item, isFamily, items)}</div>
                ${subscriptionControls}
                <div class="miniCartBodyItemBottom">
                    ${miniCartRenderQuantity(items, isFamily)}
                    <div class="miniCartBodyItemPrice">${discountBadge}<span>${miniCartMoney(subtotal)}</span>${compareDisplay ? `<s>${compareDisplay}</s>` : ''}</div>
                </div>
                ${isFamily ? '' : miniCartRenderQuantityNote(items)}
                ${otpSubscribeButton}
            </div>
        </div>
    `;
}

function miniCartGroupItems(items) {
    const order = [];
    const groups = {};
    items.forEach(item => {
        const groupKey = miniCartDuplicateGroupKey(item);
        if (!groups[groupKey]) {
            groups[groupKey] = [];
            order.push(groupKey);
        }
        groups[groupKey].push(item);
    });
    return order.map(groupKey => groups[groupKey]);
}

function miniCartRenderItems(items, isFamily) {
    if (isFamily) return miniCartRenderItem(items, true);
    // Mixed cart: the family-pack lines (added from the PDP buy box) still
    // render as ONE unified card — same treatment as the pure family cart —
    // while every other item keeps the normal grouped rendering.
    const familyItems = items.filter(miniCartIsFamilyPackItem);
    const restItems = items.filter(item => !miniCartIsFamilyPackItem(item));
    const familyCard = familyItems.length ? miniCartRenderItem(familyItems, true) : '';
    return familyCard + miniCartGroupItems(restItems).map(group => miniCartRenderItem(group, false)).join('');
}

// Welcome-kit gift lines stay OUT of miniCartVisibleItems so totals, family/subscription
// detection and the empty check keep seeing paid products only; they render separately.
function miniCartGiftLines() {
    return (cart.items || []).filter(item => item && item.properties && item.properties._gift);
}

function miniCartRenderGiftItem(item) {
    const details = typeof miniCartGiftDetails !== 'undefined' ? miniCartGiftDetails[String(item.variant_id)] : null;
    const finalLine = parseInt(item.final_line_price, 10) || 0;
    const originalLine = parseInt(item.original_line_price, 10) || 0;
    const compare = originalLine > finalLine ? `<s>${miniCartMoney(originalLine)}</s>` : '';
    const note = details && details.note ? details.note : 'Included with your subscription';

    return `
        <div class="miniCartBodyItem miniCartBodyItem--gift" data-key="${miniCartEscapeHtml(item.key)}">
            <img class="miniCartBodyItemImage" src="${miniCartImage(item, false)}" alt="${miniCartEscapeHtml(item.product_title)}">
            <div class="miniCartBodyItemContent">
                <div class="miniCartGiftLabel">Free gift</div>
                <div class="miniCartBodyItemTitleRow">
                    <div class="miniCartBodyItemTitle">${miniCartEscapeHtml(item.product_title)}</div>
                    <div class="miniCartBodyItemRemoveWrap">
                        <button type="button" class="miniCartBodyItemRemove" aria-label="Remove gift">
                            <svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M15.3 5.7 11 10l4.3 4.3-1 1L10 11l-4.3 4.3-1-1L9 10 4.7 5.7l1-1L10 9l4.3-4.3z"/></svg>
                        </button>
                    </div>
                </div>
                ${details && details.descriptor ? `<div class="miniCartGiftDescriptor">${miniCartEscapeHtml(details.descriptor)}</div>` : ''}
                <div class="miniCartGiftBottom">
                    <span class="miniCartGiftNote">${miniCartEscapeHtml(note)}</span>
                    <div class="miniCartBodyItemPrice"><span>${price(finalLine)}</span>${compare}</div>
                </div>
            </div>
        </div>
    `;
}

function miniCartRenderProductUpsell(productUpsell) {
    if (!productUpsell) return '';

    const product = productUpsell.product;
    const variants = productUpsell.variants;
    const selectedVariant = variants.find(variant => variant.available) || variants[0];
    const variantOptions = variants.map(variant => `
                    <option value="${miniCartEscapeHtml(variant.id)}" data-image="${miniCartEscapeHtml(variant.image)}" data-price="${variant.price}" data-compare="${variant.compareAtPrice}" ${String(variant.id) === String(selectedVariant.id) ? 'selected' : ''}>${miniCartEscapeHtml(variant.flavor)}</option>`).join('');
    const comparePrice = selectedVariant.compareAtPrice > selectedVariant.price ? `<s>${miniCartMoney(selectedVariant.compareAtPrice)}</s>` : '';

    return `
            <div id="miniCartFamilyCard" class="miniCartUpsellCard" data-handle="${miniCartEscapeHtml(product.handle)}">
                <span id="miniCartFamilyImageWrap">
                    <img id="miniCartFamilyImage" src="${miniCartEscapeHtml(selectedVariant.image)}" alt="${miniCartEscapeHtml(product.title)}" loading="lazy">
                </span>
                <span id="miniCartFamilyContent">
                    <span id="miniCartFamilyName">${miniCartEscapeHtml(product.title)}</span>
                    <span id="miniCartFamilyPrices">${comparePrice}<span>${miniCartMoney(selectedVariant.price)}</span></span>
                    <label class="miniCartUpsellVariantWrap">
                        <span class="visually-hidden">Choose flavor</span>
                        <select class="miniCartUpsellVariantSelect">${variantOptions}
                        </select>
                        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 7.5 10 12.5l5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </label>
                </span>
                <button type="button" id="miniCartFamilyAction" class="miniCartUpsellAdd" data-variant-id="${miniCartEscapeHtml(selectedVariant.id)}">Add</button>
            </div>`;
}

// Compact family-pack card for the empty-cart "most customers add" grid (Figma 2646-1258).
// Shares its price math with miniCartRenderFamilyPackOffer but always shows the subscription
// price and adds straight to a subscription via the existing miniCartAddFamilyPack flow.
function miniCartRenderEmptyFamilyCard(familyPackOffer) {
    if (!familyPackOffer) return '';

    const config = familyPackOffer.config;
    const variants = familyPackOffer.variants;
    const subscriptionTotal = variants.reduce((sum, variant) => sum + variant.subscriptionPrice, 0);
    const subscriptionCompareTotal = variants.reduce((sum, variant) => sum + Math.max(variant.compareAtPrice, variant.price), 0);
    const comparePrice = subscriptionCompareTotal > subscriptionTotal ? `<s>${miniCartMoney(subscriptionCompareTotal)}</s>` : '';
    const customImage = typeof miniCartEmptyUpsellCard1Image !== 'undefined' ? miniCartEmptyUpsellCard1Image : '';
    const image = customImage || config.image || variants.find(variant => variant.image)?.image || '';

    return `
            <div class="miniCartEmptyUpsellCard">
                <span class="miniCartEmptyUpsellImageWrap">
                    <img src="${miniCartEscapeHtml(image)}" alt="${miniCartEscapeHtml(config.productTitle)}" loading="lazy">
                </span>
                <span class="miniCartEmptyUpsellContent">
                    <span class="miniCartEmptyUpsellName">${miniCartEscapeHtml(config.productTitle)}</span>
                    <span class="miniCartEmptyUpsellFlavor">Flavor: Variety pack</span>
                    <span class="miniCartEmptyUpsellPrice"><span>${miniCartMoney(subscriptionTotal)}</span>${comparePrice}</span>
                </span>
                <button type="button" class="miniCartEmptyUpsellAdd miniCartFamilyPackAdd" data-purchase-type="subscription">Add to cart</button>
            </div>`;
}

function miniCartRenderFamilyPackOffer(familyPackOffer) {
    if (!familyPackOffer) return '';

    const config = familyPackOffer.config;
    const variants = familyPackOffer.variants;
    const oneTimeTotal = variants.reduce((sum, variant) => sum + variant.price, 0);
    const subscriptionTotal = variants.reduce((sum, variant) => sum + variant.subscriptionPrice, 0);
    const subscriptionCompareTotal = variants.reduce((sum, variant) => sum + Math.max(variant.compareAtPrice, variant.price), 0);
    const subscribeLabel = miniCartFamilyPackSubscribeLabel(config, subscriptionCompareTotal, subscriptionTotal);
    const comparePrice = subscriptionCompareTotal > subscriptionTotal ? `<s>${miniCartMoney(subscriptionCompareTotal)}</s>` : '';
    const copy = typeof miniCartFamilyPackCardCopy !== 'undefined' ? miniCartFamilyPackCardCopy : {};
    // Pack contents line from the configured slot labels ("1 Adults pouch (Unflavored)"),
    // falling back to the resolved variant flavors.
    const slotLabels = config.slots.map(slot => slot.label).filter(Boolean);
    const packContents = (slotLabels.length ? slotLabels : variants.map(variant => variant.flavor).filter(Boolean)).join(' + ');
    const giftDetails = typeof miniCartGiftDetails !== 'undefined' ? miniCartGiftDetails : {};
    const giftChips = (typeof miniCartGiftShowcase !== 'undefined' ? miniCartGiftShowcase : [])
        .map(variantId => giftDetails[variantId])
        .filter(gift => gift && gift.name)
        .map(gift => `
                    <span class="miniCartFamilyGift">
                        <span class="miniCartFamilyGiftThumb">${gift.image ? `<img src="${miniCartEscapeHtml(gift.image)}" alt="" loading="lazy">` : ''}</span>
                        <span class="miniCartFamilyGiftInfo">
                            <span class="miniCartFamilyGiftName">${miniCartEscapeHtml(gift.name)}</span>
                            <span class="miniCartFamilyGiftPrice">${gift.priceLabel ? `<s>${miniCartEscapeHtml(gift.priceLabel)}</s>` : ''}<em>${miniCartEscapeHtml(copy.freeLabel || 'FREE')}</em></span>
                        </span>
                    </span>`).join('');

    return `
            <div id="miniCartFamilyCard" class="miniCartUpsellCard miniCartFamilyPackCard">
                ${copy.badge ? `<span id="miniCartFamilyBadge">${miniCartEscapeHtml(copy.badge)}</span>` : ''}
                <span id="miniCartFamilyBody">
                    <span id="miniCartFamilyTop">
                        <span id="miniCartFamilyHeading">
                            <span id="miniCartFamilyName">${miniCartEscapeHtml(copy.cardTitle || 'Family Pack')}</span>
                            <span id="miniCartFamilySmall">${miniCartEscapeHtml(packContents)}</span>
                        </span>
                        <span id="miniCartFamilyPrices" data-otp-price="${oneTimeTotal}" data-subscription-price="${subscriptionTotal}" data-subscription-compare="${subscriptionCompareTotal}"><span>${miniCartMoney(subscriptionTotal)}</span>${comparePrice}</span>
                    </span>
                    <span id="miniCartFamilyDivider"></span>
                    <span id="miniCartFamilyControls">
                        <label class="miniCartUpsellVariantWrap miniCartFamilyPurchaseWrap">
                            <span class="visually-hidden">Family pack purchase option</span>
                            <select class="miniCartUpsellVariantSelect miniCartFamilyPurchaseSelect">
                                <option value="subscription" data-price="${subscriptionTotal}" data-compare="${subscriptionCompareTotal}" selected>${miniCartEscapeHtml(subscribeLabel)}</option>
                                <option value="otp" data-price="${oneTimeTotal}" data-compare="0">${miniCartEscapeHtml(config.otpLabel)}</option>
                            </select>
                            <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 7.5 10 12.5l5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </label>
                        <button type="button" id="miniCartFamilyAction" class="miniCartFamilyPackAdd" data-purchase-type="subscription">Add</button>
                    </span>
                    ${copy.kitNote ? `<span id="miniCartFamilyKitNote">${miniCartEscapeHtml(copy.kitNote)}</span>` : ''}
                    ${giftChips ? `<span id="miniCartFamilyGifts">${giftChips}</span>` : ''}
                </span>
            </div>`;
}

function miniCartUpdateHeaderCount(items, isFamily, giftQuantity = 0) {
    const visibleCount = (isFamily ? 1 : items.reduce((sum, item) => sum + item.quantity, 0)) + giftQuantity;
    const paddedCount = String(visibleCount).padStart(2, '0');
    const headerCount = document.querySelector('#miniCartHeaderCount');
    const headerIcon = document.querySelector('#headerIconsCart');
    if (headerCount) headerCount.textContent = paddedCount;
    if (headerIcon) headerIcon.textContent = `Cart(${visibleCount})`;
}

// Incentive progress bar under the header. Binary: it only unlocks (fills) when the cart
// holds a subscription; 'empty' and 'otp' render the same locked visual with different copy.
function miniCartUpdateProgress(state) {
    const progress = document.querySelector('#miniCartProgress');
    if (!progress) return;

    const heading = progress.querySelector('#miniCartProgressHeading');
    const isUnlocked = state === 'unlocked';
    progress.dataset.state = state;
    progress.classList.toggle('is-unlocked', isUnlocked);
    progress.classList.toggle('is-locked', !isUnlocked);
    if (heading) heading.textContent = progress.dataset[`text${state.charAt(0).toUpperCase()}${state.slice(1)}`] || '';
}

// Footer breakdown: SUBTOTAL is the pre-discount price, DISCOUNT covers both subscription
// savings and Shopify automatic/code discounts, TOTAL matches what SKIO charges at checkout.
function miniCartUpdateFooter(items, isSubscription, isFamily) {
    const total = miniCartDisplaySubtotal(items, isSubscription, isFamily);
    const item = items[0];
    const planInfo = miniCartPlanInfo(item);
    const subscriptionSavings = miniCartSubscriptionSavings(planInfo, items, isSubscription, isFamily);
    const originalTotal = items.reduce((sum, currentItem) => sum + (parseInt(currentItem.original_line_price, 10) || 0), 0);
    // Gifts count as full-value products discounted to free: their original value joins the
    // subtotal so the discount row shows subscription savings + gift value together.
    const giftValue = miniCartGiftLines().reduce((sum, gift) => sum + (parseInt(gift.original_line_price, 10) || 0), 0);
    const subtotal = Math.max(subscriptionSavings ? subscriptionSavings.baseTotal : 0, originalTotal, total) + giftValue;
    const discount = subtotal - total;

    const subtotalValue = document.querySelector('#miniCartTotalsSubtotal');
    const discountRow = document.querySelector('#miniCartTotalsDiscountRow');
    const discountValue = document.querySelector('#miniCartTotalsDiscount');
    const totalValue = document.querySelector('#miniCartTotalsTotal');

    if (subtotalValue) subtotalValue.textContent = miniCartMoney(subtotal);
    if (totalValue) totalValue.textContent = miniCartMoney(total);
    if (discountRow) discountRow.hidden = false;
    if (discountValue) discountValue.textContent = discount > 0 ? `-${miniCartMoney(discount)}` : miniCartMoney(0);
}

function miniCartPrefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// --- Customer reviews slider (drag + dots + autoplay). The drawer starts hidden, so the
// slider can only be measured/bound once the dialog is open; init runs from openCart().
const miniCartReviewsState = { index: 0, timer: null, bound: false };

function miniCartReviewsOffset(index) {
    const viewport = document.querySelector('#miniCartReviewsViewport');
    const track = document.querySelector('#miniCartReviewsTrack');
    if (!viewport || !track) return 0;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return -index * (viewport.clientWidth + gap);
}

function miniCartReviewsGoTo(index) {
    const track = document.querySelector('#miniCartReviewsTrack');
    if (!track || !track.children.length) return;
    const count = track.children.length;
    miniCartReviewsState.index = ((index % count) + count) % count;
    track.style.transform = `translateX(${miniCartReviewsOffset(miniCartReviewsState.index)}px)`;
    document.querySelectorAll('#miniCartReviewsDots button').forEach((dot, dotIndex) => {
        const isActive = dotIndex === miniCartReviewsState.index;
        dot.classList.toggle('active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
}

function miniCartReviewsStopAutoplay() {
    if (miniCartReviewsState.timer) clearInterval(miniCartReviewsState.timer);
    miniCartReviewsState.timer = null;
}

function miniCartReviewsStartAutoplay() {
    if (miniCartReviewsState.timer || miniCartPrefersReducedMotion()) return;
    const track = document.querySelector('#miniCartReviewsTrack');
    if (!track || track.children.length < 2) return;
    miniCartReviewsState.timer = setInterval(() => miniCartReviewsGoTo(miniCartReviewsState.index + 1), 5000);
}

function miniCartInitReviews() {
    const viewport = document.querySelector('#miniCartReviewsViewport');
    const track = document.querySelector('#miniCartReviewsTrack');
    const dots = document.querySelector('#miniCartReviewsDots');
    if (!viewport || !track || !track.children.length) return;

    if (!miniCartReviewsState.bound) {
        miniCartReviewsState.bound = true;

        if (dots) {
            Array.from(track.children).forEach((card, cardIndex) => {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.setAttribute('role', 'tab');
                dot.setAttribute('aria-label', `Review ${cardIndex + 1}`);
                dot.addEventListener('click', () => {
                    miniCartReviewsStopAutoplay();
                    miniCartReviewsGoTo(cardIndex);
                });
                dots.appendChild(dot);
            });
        }

        let dragStartX = null;
        viewport.addEventListener('pointerdown', event => {
            dragStartX = event.clientX;
            miniCartReviewsStopAutoplay();
            track.style.transition = 'none';
            viewport.setPointerCapture(event.pointerId);
        });
        viewport.addEventListener('pointermove', event => {
            if (dragStartX === null) return;
            track.style.transform = `translateX(${miniCartReviewsOffset(miniCartReviewsState.index) + (event.clientX - dragStartX)}px)`;
        });
        const endDrag = event => {
            if (dragStartX === null) return;
            const dragDelta = event.clientX - dragStartX;
            dragStartX = null;
            track.style.transition = '';
            if (dragDelta < -40) miniCartReviewsGoTo(miniCartReviewsState.index + 1);
            else if (dragDelta > 40) miniCartReviewsGoTo(miniCartReviewsState.index - 1);
            else miniCartReviewsGoTo(miniCartReviewsState.index);
        };
        viewport.addEventListener('pointerup', endDrag);
        viewport.addEventListener('pointercancel', endDrag);
    }

    miniCartReviewsGoTo(miniCartReviewsState.index);
    miniCartReviewsStartAutoplay();
}

// --- Benefits ticker: infinite marquee (cloned groups + rAF), same pattern as
// c-benefits-ticker.liquid. Re-measured on every open; paused while the drawer is closed.
const miniCartTickerState = { rafId: null };

function miniCartStopTicker() {
    if (miniCartTickerState.rafId) cancelAnimationFrame(miniCartTickerState.rafId);
    miniCartTickerState.rafId = null;
}

function miniCartStartTicker() {
    const ticker = document.querySelector('#miniCartTicker');
    const track = document.querySelector('#miniCartTickerTrack');
    const group = track && track.querySelector('.miniCartTickerGroup');
    if (!ticker || !group || !group.children.length) return;

    miniCartStopTicker();
    track.querySelectorAll('.miniCartTickerGroup[data-clone]').forEach(clone => clone.remove());
    track.style.transform = 'translateX(0)';
    if (miniCartPrefersReducedMotion()) return;

    const tickerWidth = ticker.offsetWidth;
    const groupWidth = group.scrollWidth;
    if (!tickerWidth || !groupWidth) return;

    const clonesNeeded = Math.max(2, Math.ceil((tickerWidth * 2) / groupWidth) + 1);
    for (let i = 0; i < clonesNeeded; i++) {
        const clone = group.cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        track.appendChild(clone);
    }

    const pxPerMs = groupWidth / 25000;
    let pos = 0;
    let lastTime = null;

    function tick(now) {
        if (lastTime !== null) {
            pos -= pxPerMs * (now - lastTime);
            if (pos <= -groupWidth) pos += groupWidth;
            track.style.transform = `translateX(${pos}px)`;
        }
        lastTime = now;
        miniCartTickerState.rafId = requestAnimationFrame(tick);
    }

    miniCartTickerState.rafId = requestAnimationFrame(tick);
}

function miniCartSetLoading(isLoading) {
    const content = document.querySelector('#miniCartContent');
    if (content) {
        content.classList.toggle('loading', isLoading);
        content.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }
}

function miniCartStablePropertiesKey(properties) {
    const props = properties || {};
    return JSON.stringify(Object.keys(props).sort().reduce((memo, key) => {
        memo[key] = props[key];
        return memo;
    }, {}));
}

function miniCartDuplicateGroupKey(item) {
    const planId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.id
        : '';
    return [item.variant_id, planId, miniCartStablePropertiesKey(item.properties)].join('|');
}

async function miniCartChangeQuantity(keys, quantity) {
    if (!keys.length || quantity < 1) return;
    if (miniCartActionInProgress) return;

    const matchingItems = (cart.items || []).filter(item => keys.includes(item.key));
    if (!matchingItems.length) return;

    miniCartActionInProgress = true;

    miniCartSetLoading(true);
    try {
        // A subscription with the "FREE GIFTS" (Buy X Get Y) discount is split by
        // Shopify into several lines that can never merge. Set the whole quantity on
        // the first line and zero the rest in a single atomic update so the total is
        // always correct and we never create a stray extra line.
        const updates = matchingItems.reduce((memo, currentItem, index) => {
            memo[currentItem.key] = index === 0 ? quantity : 0;
            return memo;
        }, {});

        await updateCart({ updates });
        await openCart();
    } catch (error) {
        console.error('Mini cart quantity update failed', error);
        miniCartSetLoading(false);
    } finally {
        miniCartActionInProgress = false;
    }
}

async function miniCartChangePlan(keys, quantity, sellingPlanId) {
    if (!keys.length || quantity < 1) return;
    if (miniCartActionInProgress) return;

    miniCartActionInProgress = true;

    miniCartSetLoading(true);

    try {
        const matchingItems = (cart.items || []).filter(item => keys.includes(item.key));
        if (!matchingItems.length) return;

        const ownerId = String(matchingItems[0].variant_id);

        // The product's "FREE GIFTS" (Buy X Get Y) discount splits a single subscription
        // purchase across several linked lines whose quantities Shopify rebalances on its
        // own. They can't be collapsed or re-planned line by line: zeroing one line just
        // makes Shopify redistribute the units onto the rest, and changing one line's plan
        // leaves the other split lines behind, inflating the total (e.g. a qty-3 sub became
        // qty-4 on every plan switch). Remove every line of this product and re-add it once
        // with the new plan at the existing total quantity, so only the subscription changes.
        const totalQuantity = quantity;

        const removals = matchingItems.reduce((memo, currentItem) => {
            memo[currentItem.key] = 0;
            return memo;
        }, {});
        await updateCart({ updates: removals });

        await addProduct({
            items: [{
                id: parseInt(ownerId, 10),
                quantity: totalQuantity,
                selling_plan: sellingPlanId ? parseInt(sellingPlanId, 10) : null,
                properties: sellingPlanId ? { _selling_plan_offer: String(sellingPlanId) } : {}
            }]
        });

        cart = await getCart();

        // Switching to a subscription gives this product the base welcome-kit pair (the
        // premium gift is family-pack-only); switching to one-time leaves it without one.
        // miniCartPurgeOrphanGifts() (run in openCart) removes gifts whose subscription is gone.
        if (sellingPlanId) {
            await miniCartSyncGiftSet(ownerId, false);
        }

        await openCart();
    } catch (error) {
        console.error('Mini cart selling plan update failed', error);
        await openCart().catch(() => miniCartSetLoading(false));
    } finally {
        miniCartActionInProgress = false;
    }
}

// Mixed-cart variant of the family plan switch. miniCartAddFamilyPack clears
// and rebuilds the WHOLE cart, which is only acceptable when the pack is the
// whole cart — here we re-plan just the pack's own lines, preserving their
// _family_pack properties, and swap the gift set (premium gift is
// subscription-only; switching to one-time lets openCart's purge drop gifts).
async function miniCartChangeFamilyPlan(keys, sellingPlanId) {
    if (!keys.length) return;
    if (miniCartActionInProgress) return;

    miniCartActionInProgress = true;
    miniCartSetLoading(true);

    try {
        const matchingItems = (cart.items || []).filter(item => keys.includes(item.key));
        if (!matchingItems.length) return;

        const ownerId = String(matchingItems[0].variant_id);
        const planId = sellingPlanId ? parseInt(sellingPlanId, 10) : null;

        const removals = matchingItems.reduce((memo, currentItem) => {
            memo[currentItem.key] = 0;
            return memo;
        }, {});
        await updateCart({ updates: removals });

        await addProduct({
            items: matchingItems.map(currentItem => {
                const properties = Object.assign({}, currentItem.properties);
                if (planId) {
                    properties._selling_plan_offer = String(planId);
                } else {
                    delete properties._selling_plan_offer;
                }
                return {
                    id: currentItem.variant_id,
                    quantity: currentItem.quantity,
                    selling_plan: planId,
                    properties
                };
            })
        });

        cart = await getCart();

        if (planId) {
            await miniCartSyncGiftSet(ownerId, true);
        }

        await openCart();
    } catch (error) {
        console.error('Mini cart family plan update failed', error);
        await openCart().catch(() => miniCartSetLoading(false));
    } finally {
        miniCartActionInProgress = false;
    }
}

async function miniCartRemoveItem(keys = '') {
    if (miniCartActionInProgress) return;

    miniCartActionInProgress = true;
    miniCartSetLoading(true);
    try {
        const keyList = (Array.isArray(keys) ? keys : String(keys).split('|')).filter(Boolean);
        if (keyList.length) {
            // Remove every discount-split line of the item in one update (a qty>1 subscription
            // lives across several lines). openCart's miniCartPurgeOrphanGifts() then drops any
            // gifts left without a subscription so nothing free becomes chargeable.
            const updates = keyList.reduce((memo, key) => {
                memo[key] = 0;
                return memo;
            }, {});
            await updateCart({ updates });
        } else {
            await fetch('/cart/clear.js');
        }
        await openCart();
    } catch (error) {
        console.error('Mini cart remove failed', error);
        miniCartSetLoading(false);
    } finally {
        miniCartActionInProgress = false;
    }
}

function miniCartGiftPayload(ownerVariantId = '', includePremium = false) {
    const giftItems = includePremium ? miniCartGiftItems.concat([miniCartPremiumGiftItem]) : miniCartGiftItems;
    return giftItems.map(item => ({
        id: item.id,
        quantity: item.quantity,
        properties: Object.assign({}, item.properties, ownerVariantId ? { _gift_for: String(ownerVariantId) } : {})
    }));
}

// Make the owner's gift lines match the set it earns: individual subscriptions keep the
// base pair, only family pack subscriptions add the premium gift. Replaces the whole set
// when it drifts (e.g. a plan switch), since "add only if missing" left stale sets behind.
async function miniCartSyncGiftSet(ownerVariantId, includePremium) {
    const expected = miniCartGiftPayload(ownerVariantId, includePremium);
    const currentGiftLines = (cart.items || []).filter(item => (
        item.properties && item.properties._gift &&
        String(item.properties._gift_for) === String(ownerVariantId)
    ));
    const currentIds = currentGiftLines.map(item => String(item.variant_id)).sort().join('|');
    const expectedIds = expected.map(item => String(item.id)).sort().join('|');
    if (currentIds === expectedIds) return;

    if (currentGiftLines.length) {
        const updates = currentGiftLines.reduce((memo, item) => {
            memo[item.key] = 0;
            return memo;
        }, {});
        await updateCart({ updates });
    }
    await addProduct({ items: expected });
    cart = await getCart();
}

function miniCartSubscriptionOwnerIds() {
    return (cart.items || [])
        .filter(item => item.selling_plan_allocation && !(item.properties && item.properties._gift))
        .map(item => String(item.variant_id));
}

// Each subscription carries its own welcome-kit gifts (tagged with _gift_for). Drop any
// gift line whose owning subscription is no longer in the cart so the "FREE GIFTS" discount
// always covers every gift and the customer is never charged for an orphaned one.
async function miniCartPurgeOrphanGifts() {
    const owners = miniCartSubscriptionOwnerIds();
    const updates = (cart.items || []).reduce((memo, item) => {
        if (!item.properties || !item.properties._gift) return memo;
        const owner = item.properties._gift_for ? String(item.properties._gift_for) : '';
        const orphaned = !owners.length || (owner && !owners.includes(owner));
        if (orphaned) memo[item.key] = 0;
        return memo;
    }, {});

    if (!Object.keys(updates).length) return false;
    await updateCart({ updates });
    return true;
}

async function miniCartSubscribeCurrentItem(key = '') {
    if (miniCartActionInProgress) return;

    miniCartActionInProgress = true;

    miniCartSetLoading(true);

    try {
        const items = miniCartVisibleItems();
        const item = key ? items.find(currentItem => currentItem.key === key) : items[0];
        const planId = await miniCartResolveSellingPlanId(item);

        if (!item || !planId) return;

        await changeCart({
            id: item.key,
            quantity: item.quantity,
            selling_plan: parseInt(planId, 10)
        });
        cart = await getCart();
        const ownerId = String(item.variant_id);
        await miniCartSyncGiftSet(ownerId, false);
        await openCart();
    } catch (error) {
        console.error('Mini cart subscribe failed', error);
        await openCart().catch(() => miniCartSetLoading(false));
    } finally {
        miniCartActionInProgress = false;
    }
}

async function miniCartAddProductUpsell(variantId) {
    if (miniCartActionInProgress) return;
    if (!variantId) return;

    miniCartActionInProgress = true;
    miniCartSetLoading(true);
    try {
        await addProduct({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        });
        await openCart();
    } catch (error) {
        console.error('Mini cart product upsell failed', error);
        miniCartSetLoading(false);
    } finally {
        miniCartActionInProgress = false;
    }
}

async function miniCartFamilyPackPayload(purchaseType = 'subscription') {
    const config = miniCartFamilyPackConfig();
    if (config.slots.length < 2) throw new Error('Family pack slots were not configured');

    // Resolve each slot's product so we can label the line with the variant flavor; the variant ID
    // itself comes straight from the customizer config, so the add never depends on flavor matching.
    const products = await Promise.all(config.slots.map(slot => miniCartFetchProduct(slot.handle)));

    const isSubscription = purchaseType === 'subscription' || String(purchaseType) === String(config.sellingPlanId);
    return config.slots.map((slot, index) => {
        const variant = miniCartFindVariantById(products[index], slot.variantId);
        if (!variant) throw new Error('Family pack variant was not found');

        const payload = {
            id: parseInt(variant.id, 10),
            quantity: 1,
            properties: {
                _family_pack: true,
                _family_pack_flavor: slot.label || miniCartVariantFlavor(variant),
                // Mirror the PDP variety flow so other components recognize the pack consistently.
                _variety: true
            }
        };

        if (isSubscription) {
            payload.selling_plan = parseInt(config.sellingPlanId, 10);
            payload.properties._selling_plan_offer = config.sellingPlanId;
        }

        return payload;
    });
}

async function miniCartAddFamilyPack(purchaseType = 'subscription') {
    if (miniCartActionInProgress) return;

    miniCartActionInProgress = true;
    miniCartSetLoading(true);

    try {
        const items = await miniCartFamilyPackPayload(purchaseType);
        await fetch('/cart/clear.js');
        await addProduct({ items });

        // A subscription family pack always earns the full welcome kit including the premium
        // gift. The cart was just cleared, so add one gift set tied to a pack variant; switching
        // the pack to one-time rebuilds the cart without a plan, so the gifts won't carry over.
        const subscriptionItem = items.find(item => item.selling_plan);
        if (subscriptionItem) {
            await addProduct({ items: miniCartGiftPayload(String(subscriptionItem.id), true) });
        }

        await openCart();
    } catch (error) {
        console.error('Mini cart family pack failed', error);
        miniCartSetLoading(false);
    } finally {
        miniCartActionInProgress = false;
    }
}

// Re-resolve the product group from the LIVE cart at click time. The data-keys captured at
// render time can go stale when a quantity change shifts the automatic-discount tier and
// Shopify re-splits/re-keys the line; trusting them would make the buttons silently no-op.
// We match by duplicate-group key (variant + plan + properties) so we always act on the
// real current lines, falling back to whichever rendered keys still exist.
function miniCartResolveGroup(keys) {
    const liveItems = cart.items || [];
    const seedItem = keys.map(key => liveItems.find(item => item.key === key)).find(Boolean);
    if (seedItem) {
        const groupKey = miniCartDuplicateGroupKey(seedItem);
        const groupItems = liveItems.filter(item => miniCartDuplicateGroupKey(item) === groupKey);
        if (groupItems.length) return groupItems;
    }
    return liveItems.filter(item => keys.includes(item.key));
}

function miniCartBindDynamicEvents() {
    document.querySelectorAll('.miniCartQuantityMinus').forEach(button => {
        button.addEventListener('click', function () {
            const control = this.closest('.miniCartQuantity');
            const keys = control.dataset.keys.split('|').filter(Boolean);
            const items = miniCartResolveGroup(keys);
            // Keys no longer in the cart: the UI is out of sync, so resync instead of no-op.
            if (!items.length) { openCart(); return; }
            const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
            const currentKeys = items.map(item => item.key);
            const minQuantity = parseInt(control.dataset.minQuantity, 10) || 1;
            // At the floor: only remove the line when the floor is 1 (OTP / 4-week).
            // Subscriptions with a higher floor (12-week -> 3) just stop decreasing.
            if (quantity <= minQuantity) {
                if (minQuantity <= 1) miniCartRemoveItem(currentKeys.join('|'));
                return;
            }
            miniCartChangeQuantity(currentKeys, quantity - 1);
        });
    });

    document.querySelectorAll('.miniCartQuantityPlus').forEach(button => {
        button.addEventListener('click', function () {
            const control = this.closest('.miniCartQuantity');
            const keys = control.dataset.keys.split('|').filter(Boolean);
            const items = miniCartResolveGroup(keys);
            if (!items.length) { openCart(); return; }
            const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
            const currentKeys = items.map(item => item.key);
            miniCartChangeQuantity(currentKeys, quantity + 1);
        });
    });

    document.querySelectorAll('.miniCartBodyItemRemove').forEach(button => {
        button.addEventListener('click', function () {
            const item = this.closest('.miniCartBodyItem');
            const isFamilyCard = Boolean(item && item.classList.contains('miniCartBodyItem--family'));
            // Clearing the whole cart is only correct when the family pack IS the
            // whole cart; in a mixed cart the card removes just its own lines
            // (openCart's purge then drops the pack's orphaned gifts).
            if (isFamilyCard && miniCartIsFamilyCart(miniCartVisibleItems())) {
                miniCartRemoveItem('');
                return;
            }
            miniCartRemoveItem(item?.dataset.keys || item?.dataset.key || '');
        });
    });

    document.querySelectorAll('.miniCartBodyItemPlanSelect').forEach(select => {
        select.addEventListener('change', function () {
            const keys = (this.dataset.keys || '').split('|').filter(Boolean);
            const selectedOption = this.options[this.selectedIndex];
            const planQuantity = selectedOption && selectedOption.dataset.planQuantity
                ? parseInt(selectedOption.dataset.planQuantity, 10)
                : parseInt(this.dataset.quantity, 10);
            miniCartChangePlan(keys, planQuantity, this.value);
        });
    });

    document.querySelectorAll('.miniCartFamilyPlanSelect').forEach(select => {
        select.addEventListener('change', function () {
            // Pure family cart keeps the historical rebuild flow (clear + re-add).
            if (miniCartIsFamilyCart(miniCartVisibleItems())) {
                miniCartAddFamilyPack(this.value || 'otp');
                return;
            }
            // Mixed cart: re-plan only this card's lines; never touch the rest.
            const card = this.closest('.miniCartBodyItem');
            const keys = card && card.dataset.keys ? card.dataset.keys.split('|').filter(Boolean) : [];
            miniCartChangeFamilyPlan(keys, this.value || '');
        });
    });

    document.querySelectorAll('.miniCartItemSubscribe, .miniCartOtpSubscribe').forEach(button => {
        if (button.tagName.toLowerCase() === 'button') {
            button.addEventListener('click', function () {
                miniCartSubscribeCurrentItem(this.dataset.key || '');
            });
        }
    });

    document.querySelectorAll('.miniCartUpsellVariantSelect').forEach(select => {
        select.addEventListener('change', function () {
            const option = this.options[this.selectedIndex];
            const card = this.closest('.miniCartUpsellCard');
            const isFamilyPackCard = Boolean(card && card.classList.contains('miniCartFamilyPackCard'));
            const image = card && card.querySelector('#miniCartFamilyImage');
            const price = card && card.querySelector('#miniCartFamilyPrices');
            const button = card && (card.querySelector('.miniCartUpsellAdd') || card.querySelector('.miniCartFamilyPackAdd'));
            const compareAtPrice = parseInt(option.dataset.compare, 10) || 0;
            const variantPrice = parseInt(option.dataset.price, 10) || 0;
            const compareHtml = compareAtPrice > variantPrice ? `<s>${miniCartMoney(compareAtPrice)}</s>` : '';

            if (image && option.dataset.image) image.src = option.dataset.image;
            // The family pack card shows price-then-compare; the product upsell keeps compare first.
            if (price) price.innerHTML = isFamilyPackCard
                ? `<span>${miniCartMoney(variantPrice)}</span>${compareHtml}`
                : `${compareHtml}<span>${miniCartMoney(variantPrice)}</span>`;
            if (button) button.dataset.variantId = option.value;
            if (button && button.classList.contains('miniCartFamilyPackAdd')) button.dataset.purchaseType = option.value;
            // One-time packs don't earn the welcome kit, so hide the kit note and gift chips.
            if (isFamilyPackCard) card.classList.toggle('is-otp', option.value === 'otp');
        });
    });

    document.querySelectorAll('.miniCartUpsellAdd').forEach(button => {
        button.addEventListener('click', function () {
            miniCartAddProductUpsell(this.dataset.variantId);
        });
    });

    document.querySelectorAll('.miniCartFamilyPackAdd').forEach(button => {
        button.addEventListener('click', function () {
            miniCartAddFamilyPack(this.dataset.purchaseType || 'subscription');
        });
    });
}

async function openCart(skipFetch = false) {
    const dialog = document.querySelector('#miniCart');
    if (!dialog) return;

    if (dialog.matches(':not([open])')) dialog.showModal();
    document.body.classList.add('noScroll');
    miniCartSetLoading(true);

    try {
        if (skipFetch === false) cart = await getCart();

        // Keep each subscription's welcome-kit gifts in sync: drop any gift whose owning
        // subscription is no longer in the cart so the "FREE GIFTS" discount always applies.
        if (await miniCartPurgeOrphanGifts()) cart = await getCart();

        // Discount-split subscription lines (the "FREE GIFTS" Buy X Get Y discount keeps
        // one entitled unit on its own line) can never be physically merged in Shopify, so
        // we group them only for display instead of fighting the cart with remove/re-add.
        const visibleItems = miniCartVisibleItems();
        await miniCartHydrateSellingPlans(visibleItems);
        const isFamily = miniCartIsFamilyCart(visibleItems);
        const isSubscription = visibleItems.some(item => item && item.selling_plan_allocation);
        const empty = document.querySelector('#miniCartEmpty');
        const body = document.querySelector('#miniCartBody');
        const footer = document.querySelector('#miniCartFooter');
        const itemsContainer = document.querySelector('#miniCartItems');
        const family = document.querySelector('#miniCartFamily');
        const upsellSlot = document.querySelector('#miniCartUpsellSlot');

        const giftLines = miniCartGiftLines();
        const giftQuantity = giftLines.reduce((sum, item) => sum + item.quantity, 0);

        miniCartUpdateHeaderCount(visibleItems, isFamily, giftQuantity);

        if (!visibleItems.length) {
            miniCartUpdateProgress('empty');
            empty?.classList.add('active');
            body?.classList.remove('active');
            footer?.classList.remove('active');
            if (itemsContainer) itemsContainer.innerHTML = '';

            const emptyUpsellGrid = document.querySelector('#miniCartEmptyUpsellGrid');
            if (emptyUpsellGrid) {
                const [emptyFamilyOffer, emptyUpsellProduct] = await Promise.all([
                    miniCartResolveFamilyPackOffer([]),
                    miniCartResolveEmptyUpsellProduct()
                ]);
                emptyUpsellGrid.innerHTML = miniCartRenderEmptyFamilyCard(emptyFamilyOffer) + miniCartRenderProductUpsell(emptyUpsellProduct);
                // Figma's empty-cart cards both read "Add to cart"; the shared render keeps
                // "Add" for the in-cart upsell context, so relabel just this instance.
                const emptyUpsellAddButton = emptyUpsellGrid.querySelector('.miniCartUpsellAdd');
                if (emptyUpsellAddButton) emptyUpsellAddButton.textContent = 'Add to cart';
                miniCartBindDynamicEvents();
            }
            return;
        }

        empty?.classList.remove('active');
        body?.classList.add('active');
        footer?.classList.add('active');

        miniCartUpdateProgress(isSubscription ? 'unlocked' : 'otp');
        miniCartUpdateFooter(visibleItems, isSubscription, isFamily);

        const familyPackOffer = await miniCartResolveFamilyPackOffer(visibleItems);

        if (itemsContainer) itemsContainer.innerHTML = miniCartRenderItems(visibleItems, isFamily) + giftLines.map(miniCartRenderGiftItem).join('');
        if (upsellSlot) upsellSlot.innerHTML = miniCartRenderFamilyPackOffer(familyPackOffer);
        family?.classList.toggle('is-hidden', isFamily || !familyPackOffer);
        miniCartBindDynamicEvents();
        miniCartInitReviews();
        miniCartStartTicker();
    } catch (error) {
        console.error('Mini cart render failed', error);
    } finally {
        miniCartSetLoading(false);
    }
}

function closeCart() {
    const dialog = document.querySelector('#miniCart');
    if (dialog && dialog.open) dialog.close();
}

document.querySelector('#miniCart')?.addEventListener('close', function () {
    document.body.classList.remove('noScroll');
    miniCartStopTicker();
    miniCartReviewsStopAutoplay();
});

document.querySelectorAll('.openCart').forEach(element => {
    element.addEventListener('click', function (event) {
        event.preventDefault();
        openCart();
    });
});

document.querySelectorAll('.closeCart').forEach(element => {
    element.addEventListener('click', closeCart);
});

document.querySelector('#miniCart')?.addEventListener('click', function (event) {
    if (event.target === this) closeCart();
});

document.querySelector('#miniCartFooterCheckout')?.addEventListener('click', function () {
    this.classList.add('loading');
    window.location.href = `${Shopify.routes.root}checkout`;
});

if (document.referrer.includes('/cart')) {
    openCart().catch(err => console.log(err));
}
